// Small glyphs for the audio controls, drawn in currentColor.

export function PlayGlyph({ size = 10 }: { size?: number }) {
  // The design's CSS triangle: slightly wider than tall, nudged right to look centred.
  return (
    <svg aria-hidden width={size} height={Math.round(size * 1.2)} viewBox="0 0 10 12" className="ml-[2px] shrink-0" fill="currentColor">
      <path d="M0 0 L10 6 L0 12 Z" />
    </svg>
  )
}

export function PauseGlyph({ size = 12 }: { size?: number }) {
  return (
    <svg aria-hidden width={Math.round(size * 0.75)} height={size} viewBox="0 0 9 12" className="shrink-0" fill="currentColor">
      <rect x="0" y="0" width="3" height="12" rx="1" />
      <rect x="6" y="0" width="3" height="12" rx="1" />
    </svg>
  )
}

export function StopGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg aria-hidden width={size} height={size} viewBox="0 0 16 16" className="shrink-0" fill="currentColor">
      <rect x="0" y="0" width="16" height="16" rx="3" />
    </svg>
  )
}

export function MicGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className="shrink-0"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" />
    </svg>
  )
}
